import * as THREE from 'three';
import { offscreen } from './platform.js';
import { resizeTextureCanvas } from './canvasTexture.js';
import { discoveryNoticeLayout, explorationLayout } from './exploration.js';
import { wrapCanvasText } from './mobileLayout.js';
import { pill, UI_COLORS } from './uiArt.js';

export function createExplorationHud(hudScene) {
  const canvas = offscreen(700,96), texture = new THREE.CanvasTexture(canvas);
  texture.colorSpace=THREE.SRGBColorSpace;
  const sprite = new THREE.Sprite(new THREE.SpriteMaterial({map:texture,depthTest:false,depthWrite:false}));
  sprite.center.set(0,1);sprite.renderOrder=2; sprite.visible=false;hudScene.add(sprite);
  const noticeCanvas=offscreen(800,156), noticeTexture=new THREE.CanvasTexture(noticeCanvas);
  noticeTexture.colorSpace=THREE.SRGBColorSpace;
  const noticeSprite=new THREE.Sprite(new THREE.SpriteMaterial({map:noticeTexture,depthTest:false,depthWrite:false,transparent:true}));
  noticeSprite.center.set(0,1);noticeSprite.renderOrder=3;noticeSprite.visible=false;hudScene.add(noticeSprite);
  let notice=null, noticePaint='';
  let lastPaint='';
  return {
    announce(event) { notice={...event,elapsed:0};noticePaint=''; },
    update({screen,target,show,navRect,statusRect,controlsRect,azimuth=-.72,seconds=0}) {
      noticeSprite.visible=false;
      const noticeRect=notice && discoveryNoticeLayout(screen,{statusRect,navRect,controlsRect});
      if(notice && show && noticeRect) {
        notice.elapsed+=Math.max(0,Math.min(.1,seconds));
        if(notice.elapsed>3.5) notice=null;
        else {
          noticeSprite.visible=true;
          noticeSprite.scale.set(noticeRect.width,noticeRect.height,1);
          noticeSprite.position.set(noticeRect.x,screen.height-noticeRect.y,.3);
          noticeSprite.material.opacity=Math.min(1,notice.elapsed/.18,(3.5-notice.elapsed)/.45);
          const paint=JSON.stringify([notice.title,notice.detail,noticeRect.width]);
          if(paint!==noticePaint) {
            noticePaint=paint;
            resizeTextureCanvas(noticeCanvas,noticeTexture,Math.round(noticeRect.width*2),156);
            const ctx=noticeCanvas.getContext('2d'), w=noticeCanvas.width;
            ctx.clearRect(0,0,w,156);ctx.fillStyle='rgba(8,38,43,.90)';pill(ctx,0,0,w,156,16);ctx.fill();
            ctx.strokeStyle=UI_COLORS.gold;ctx.lineWidth=2;ctx.beginPath();ctx.moveTo(24,12);ctx.lineTo(w-24,12);ctx.moveTo(24,144);ctx.lineTo(w-24,144);ctx.stroke();
            ctx.fillStyle=UI_COLORS.text;ctx.textAlign='center';ctx.font='600 40px sans-serif';ctx.fillText(notice.title,w/2,65,w-36);
            ctx.fillStyle='#d5ddc5';ctx.font='26px sans-serif';
            wrapCanvasText(ctx,notice.detail,w-40,2).forEach((line,i)=>ctx.fillText(line,w/2,102+i*29));
            noticeTexture.needsUpdate=true;
          }
        }
      }
      const {compass:rect}=explorationLayout(screen,{statusRect});
      sprite.scale.set(rect.width,rect.height,1);sprite.position.set(rect.x,screen.height-rect.y,.2);
      sprite.visible=show&&rect.y+rect.height<(controlsRect?.y??navRect?.y??screen.height);
      const heading=(Math.atan2(-Math.cos(azimuth),Math.sin(azimuth))*180/Math.PI+360)%360;
      const key=JSON.stringify([target,Math.round(heading),rect.width]);if(key===lastPaint)return;lastPaint=key;
      resizeTextureCanvas(canvas,texture,Math.round(rect.width*2),96);
      const w=canvas.width,c=w/2;
      const ctx=canvas.getContext('2d');ctx.clearRect(0,0,w,96);
      ctx.strokeStyle='rgba(255,241,204,.75)';ctx.fillStyle=UI_COLORS.text;ctx.lineWidth=2;
      ctx.beginPath();ctx.moveTo(16,36);ctx.lineTo(w-16,36);ctx.stroke();
      ctx.textAlign='center';ctx.font='600 26px sans-serif';
      for(let degree=0;degree<360;degree+=15){const delta=((degree-heading+540)%360)-180,x=c+delta*w/210;
        if(x<12||x>w-12)continue;const major=degree%90===0;
        ctx.beginPath();ctx.moveTo(x,major?23:29);ctx.lineTo(x,42);ctx.stroke();
        if(major)ctx.fillText(['N','E','S','W'][degree/90],x,22);
      }
      ctx.fillStyle=UI_COLORS.gold;ctx.beginPath();ctx.moveTo(c,24);ctx.lineTo(c-8,8);ctx.lineTo(c+8,8);ctx.fill();
      if(target){ctx.fillStyle=UI_COLORS.panel;pill(ctx,8,54,w-16,40,20);ctx.fill();
        ctx.fillStyle=UI_COLORS.text;ctx.font='500 23px sans-serif';ctx.fillText(`${target.arrow} ${target.name} · ${target.distance} 米`,c,83,w-28);}
      texture.needsUpdate=true;
    },
  };
}
